import Emitter from './Emitter';
import Validator from './Validator';
import Reference from './Reference';

export default class Form extends Emitter {
  constructor(props = {}) {
    super(props);
    this.isItem = false;
    this.__parent = props.parent || null;
    this.__items = [];
    this.__rules = props.rules || [];
    this.__show = props.show === undefined ? true : props.show;
    this.__disabled = props.disabled || false;
    this.__name = props.name || null;
    this.__value = null;
    this.__submit = props.submit || (() => Promise.resolve());
    this.label = props.label || '';
    this.placeholder = props.placeholder || '';
    this.component = props.component || '';
    this.error = '';
    this.loading = false;
    this.el = null;
    this.refs = new Reference();
  }

  get value() {
    return this.get();
  }

  set value(value) {
    this.set(value);
    this.$validate()
      .catch(() => {
      });
    this.$dispatch(this);
  }

  get disabled() {
    if (this.__parent) {
      return this.__parent.disabled || this.__disabled;
    }
    return this.__disabled;
  }

  set disabled(value) {
    this.__disabled = !!value;
  }

  get show() {
    return this.__show;
  }

  set show(value) {
    this.__show = !!value;
  }

  get required() {
    return !!this.__rules.find(i => i.require);
  }

  get items() {
    return this.__items.map(i => i.item);
  }

  get data() {
    return {
      [this.__name]: this.__value,
    };
  }

  set data(data) {
    this.set(data);
  }

  get() {
    return this.__value;
  }

  set(value) {
    this.__value = value;
    return this;
  }

  setData(data) {
    this.data = data;
    return this;
  }

  submit() {
    return this.$submit();
  }

  getItem(key) {
    return this.__items.find(i => i.key === key)?.item || null;
  }

  setItem(key, item) {
    item.__parent = this;
    item.$subscribe(() => {
      this.$dispatch(this);
    });
    if (!item.__name) {
      item.__name = key;
    }
    this.__items.push({
      key,
      item,
    });
    return this;
  }

  deleteItem(key) {
    this.__items = this.__items.filter(i => i.key !== key);
    return this;
  }

  setValidator(validator, require) {
    this.__rules.push(new Validator(validator, require));
    return this;
  }

  init() {
    return Promise
      .all([
        ...this.items.map(item => item.init()),
      ]);
  }

  $validate() {
    if (this.disabled || !this.show) {
      return Promise.resolve();
    }
    if (this.el) {
      this.el.showError = true;
    }
    return Promise
      .all([
        ...this.__rules.map(validateRules(this.value)),
        ...this.items.map(item => item.$validate()),
      ])
      .then(() => {
        this.error = '';
        return Promise.resolve();
      })
      .catch((err) => {
        this.error = err;
        return Promise.reject(err);
      });
  }

  $submit() {
    return this
      .$validate()
      .then(() => Promise.all([
        ...this.items.map(item => item.submit()),
      ]));
  }
}

function validateRules(value) {
  return item => item.validator(value);
}
